module.exports = __webpack_public_path__ + "static/Verne-design-level-9bc68d7ac0e013b9e707a29c9df80630.png";